module.exports = __webpack_public_path__ + "static/images/filterSmall.3576fc135d4cffe781f8ec35239a1aaa.svg";